import { TopbarData } from '../models/topbar.model';

export const TOPBAR_DATA: TopbarData = {
  compactUser: {
    name: 'Mario',
    surname: 'Rossi',
    role: 'Admin',
    avatar: undefined,
  },
  compactUserAvatarConfig: {
    size: 'normal',
    titleSize: 'text-md',
  },
  profileCardUser: {
    name: 'Mario',
    surname: 'Rossi',
    username: 'mario.rossi',
    role: 'Admin',
    avatar: undefined,
  },
  profileCardAvatarConfig: {
    size: 'large',
    titleSize: 'text-3xl',
    type: 'vertical',
  },
};
